export default __webpack_public_path__ + "static/media/app-receitas.3c190263.png";